import { Divider, Flex } from '@approvalmax/ui/src/components';
import range from 'lodash/range';
import { memo } from 'react';
import Skeleton from 'react-loading-skeleton';

export const Loading = memo(() => {
    return (
        <>
            <Flex container spacing='32'>
                {range(6).map((index) => (
                    <Flex size={4} key={index}>
                        <Skeleton height={16} />
                    </Flex>
                ))}
            </Flex>

            <Divider spacing='12 0 0' />
        </>
    );
});

Loading.displayName = 'Loading';
